import PropTypes from 'prop-types';
import React from 'react';

const CanduText = ({ height = 220, color = 'white' }) => (
  <svg
    width={height * 3.7272}
    height={height}
    viewBox="0 0 820 220"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M75.0656 73.8999C54.3656 73.8999 36.9656 80.5 22.5656 93.9999C8.16558 107.5 0.965576 124.9 0.965576 146.5C0.965576 168.1 8.16558 185.8 22.5656 199.6C36.9656 213.1 54.3656 220 75.0656 220C97.2656 220 115.266 212.5 129.366 197.2L108.366 179.8C99.6656 189.1 88.5656 193.6 75.0656 193.6C62.1656 193.6 51.0656 189.1 41.7656 180.4C32.4656 171.7 27.9656 160.3 27.9656 146.5C27.9656 133 32.4656 121.9 41.7656 113.5C51.0656 104.8 62.1656 100.6 75.0656 100.6C88.5656 100.6 99.6656 105.1 108.366 113.8L129.066 96.4C115.266 81.3999 97.2656 73.8999 75.0656 73.8999Z"
      fill={color}
    />
    <path
      d="M298.266 217V76.9H271.266V97.8999C262.566 82.5999 242.466 73.8999 222.066 73.8999C202.266 73.8999 185.466 80.5 171.666 93.9999C157.866 107.5 150.966 124.9 150.966 146.8C150.966 168.4 157.866 186.1 171.666 199.6C185.466 213.1 202.266 220 222.066 220C242.466 220 261.966 211 271.266 195.4V217H298.266ZM270.966 146.5C270.966 160.9 266.466 172.3 257.466 180.7C248.466 189.1 237.366 193.3 224.466 193.3C211.566 193.3 200.766 188.8 192.066 180.1C183.366 171.4 178.866 160 178.866 146.5C178.866 133 183.066 121.9 191.766 113.5C200.466 104.8 211.566 100.6 224.466 100.6C236.766 100.6 247.566 104.8 256.866 112.9C266.166 121 270.966 132.4 270.966 146.5Z"
      fill={color}
    />
    <path
      d="M371.257 141.4C371.257 113.8 388.957 100.6 410.857 100.6C430.057 100.6 441.757 114.7 441.757 137.8V217H469.057V136C469.057 96.4 449.857 73.8999 415.057 73.8999C397.957 73.8999 379.357 82.2999 371.257 97.8999V76.9H343.957V217H371.257V141.4Z"
      fill={color}
    />
    <path
      d="M651 217V0.699951H623.7V97.8999C614.4 82.2999 595.5 73.8999 574.2 73.8999C554.4 73.8999 537.6 80.5 524.1 93.9999C510.6 107.5 503.7 124.9 503.7 146.8C503.7 168.4 510.6 186.1 524.1 199.6C537.9 213.1 554.7 220 574.5 220C594.9 220 614.4 211 623.7 195.4V217H651ZM576.9 100.6C589.2 100.6 600 104.8 609.3 112.9C618.6 121 623.4 132.4 623.4 146.5C623.4 160.6 618.9 172 609.6 180.7C600.6 189.1 589.8 193.3 576.9 193.3C564 193.3 553.2 188.8 544.5 180.1C535.8 171.4 531.6 160 531.6 146.5C531.6 133 535.8 121.9 544.5 113.5C553.2 104.8 564 100.6 576.9 100.6Z"
      fill={color}
    />
    <path
      d="M792.691 152.5C792.691 180.4 775.591 193.3 753.091 193.3C733.891 193.3 722.491 179.2 722.491 156.1V76.9H695.191V157.9C694.891 197.5 714.391 220 749.191 220C766.291 220 784.591 211.6 792.691 196V217H819.991V76.9H792.691V152.5Z"
      fill={color}
    />
  </svg>
);

CanduText.propTypes = {
  height: PropTypes.number,
  color: PropTypes.string,
};

export default CanduText;

// 3.72
